// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info__be4 {
  margin-top: calc(var(--ring-unit) * 2);
}

.infoBanner__f69 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & + & {
    margin-top: var(--ring-unit);
  }

  .learnMoreLink__f33 {
    display: flex;
    align-items: center;

    .rightArrowIcon__b9e {
      margin-left: calc(var(--ring-unit) / 2);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/common/plugin-rule.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;MACE,uCAAuC;IACzC;EACF;AACF","sourcesContent":[".info {\n  margin-top: calc(var(--ring-unit) * 2);\n}\n\n.infoBanner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  & + & {\n    margin-top: var(--ring-unit);\n  }\n\n  .learnMoreLink {\n    display: flex;\n    align-items: center;\n\n    .rightArrowIcon {\n      margin-left: calc(var(--ring-unit) / 2);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `info__be4`,
	"infoBanner": `infoBanner__f69`,
	"learnMoreLink": `learnMoreLink__f33`,
	"rightArrowIcon": `rightArrowIcon__b9e`
};
export default ___CSS_LOADER_EXPORT___;
